import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ApartmentInterface } from '@simOn/space/information/models';
import * as ApartmentReducer from './space.reducers';

export const SelectApartmentState = createFeatureSelector<ApartmentReducer.TSpaceState>('spaces');

export const SelectAllApartments = createSelector(SelectApartmentState, ApartmentReducer.selectAll);

export const Loading = createSelector(SelectApartmentState, (state) => state.isLoading || false);

export const SelectApartmentById = (apartmentId: string) =>
  createSelector(SelectApartmentState, (state) => state.entities[apartmentId]!);

export const GetSelectedApartmentId = createSelector(SelectApartmentState, (state) => state.selectedId);
export const GetSelectedApartment = createSelector(SelectApartmentState, (state) =>
  state.selectedId ? state.entities[state.selectedId] : undefined
);
export const GetSelectedSpaceModelId = createSelector(SelectApartmentState, (state) => state.selectedSpaceModelId);

export const SelectSelectedApartment = createSelector(
  SelectAllApartments,
  GetSelectedApartmentId,
  (apartments: ApartmentInterface[], selectedApartmentId: string | undefined) => {
    return apartments.find((apartment: ApartmentInterface) => apartment.id === selectedApartmentId);
  }
);

export const GetApartmentPhotoUrl = createSelector(
  GetSelectedApartment,
  (apartment: ApartmentInterface | undefined) => {
    return apartment?.attachment?.blobPath;
  }
);
export const DefaultSpaceModelId = createSelector(GetSelectedApartment, (apartment: ApartmentInterface | undefined) => {
  return apartment?.scanModels?.find((model) => model.isDefault)?.id || apartment?.scanModels?.[0]?.id;
});
